/* tslint:disable */

import { useAppInsights } from '@/plugins/ApplicationInsights';
import { HttpClient } from '../http-client';

export default (client: HttpClient) => {
  client.instance.interceptors.response.use(
    response => response,
    async error => {
      if (error.response?.status === 401) {
        return error.response;
      } else {
        useAppInsights().trackException({
          exception: new Error(error.message)
        });
        return error.response;
      }
    }
  );
};
